export const airports = [
  { code: "ATL", name: "Hartsfield-Jackson Atlanta International Airport", city: "Atlanta, GA" },
  { code: "LAX", name: "Los Angeles International Airport", city: "Los Angeles, CA" },
  { code: "ORD", name: "O'Hare International Airport", city: "Chicago, IL" },
  { code: "DFW", name: "Dallas/Fort Worth International Airport", city: "Dallas, TX" },
  { code: "DEN", name: "Denver International Airport", city: "Denver, CO" },
  { code: "JFK", name: "John F. Kennedy International Airport", city: "New York, NY" },
  { code: "SFO", name: "San Francisco International Airport", city: "San Francisco, CA" },
  { code: "SEA", name: "Seattle-Tacoma International Airport", city: "Seattle, WA" },
  { code: "LAS", name: "Harry Reid International Airport", city: "Las Vegas, NV" },
  { code: "MCO", name: "Orlando International Airport", city: "Orlando, FL" },
  { code: "EWR", name: "Newark Liberty International Airport", city: "Newark, NJ" },
  { code: "CLT", name: "Charlotte Douglas International Airport", city: "Charlotte, NC" },
  { code: "PHX", name: "Phoenix Sky Harbor International Airport", city: "Phoenix, AZ" },
  { code: "IAH", name: "George Bush Intercontinental Airport", city: "Houston, TX" },
  { code: "MIA", name: "Miami International Airport", city: "Miami, FL" },
  { code: "BOS", name: "Logan International Airport", city: "Boston, MA" },
  { code: "MSP", name: "Minneapolis-Saint Paul International Airport", city: "Minneapolis, MN" },
  { code: "DTW", name: "Detroit Metropolitan Wayne County Airport", city: "Detroit, MI" },
  { code: "PHL", name: "Philadelphia International Airport", city: "Philadelphia, PA" },
  { code: "LGA", name: "LaGuardia Airport", city: "New York, NY" },
  { code: "SAT", name: "San Antonio International Airport", city: "San Antonio, TX" },
  { code: "SLC", name: "Salt Lake City International Airport", city: "Salt Lake City, UT" },
  { code: "FLL", name: "Fort Lauderdale-Hollywood International Airport", city: "Fort Lauderdale, FL" },
  { code: "BWI", name: "Baltimore/Washington International Airport", city: "Baltimore, MD" },
  { code: "DCA", name: "Ronald Reagan Washington National Airport", city: "Washington, DC" },
  { code: "IAD", name: "Washington Dulles International Airport", city: "Washington, DC" },
  { code: "MDW", name: "Chicago Midway International Airport", city: "Chicago, IL" },
  { code: "SAN", name: "San Diego International Airport", city: "San Diego, CA" },
  { code: "TPA", name: "Tampa International Airport", city: "Tampa, FL" },
  { code: "PDX", name: "Portland International Airport", city: "Portland, OR" },
  { code: "RSW", name: "Southwest Florida International Airport", city: "Fort Myers, FL" },
  { code: "AUS", name: "Austin-Bergstrom International Airport", city: "Austin, TX" },
  { code: "BNA", name: "Nashville International Airport", city: "Nashville, TN" },
  { code: "MSY", name: "Louis Armstrong New Orleans International Airport", city: "New Orleans, LA" },
  { code: "RDU", name: "Raleigh-Durham International Airport", city: "Raleigh, NC" },
  { code: "HNL", name: "Daniel K. Inouye International Airport", city: "Honolulu, HI" },
  { code: "OAK", name: "Oakland International Airport", city: "Oakland, CA" },
  { code: "SJC", name: "Norman Y. Mineta San Jose International Airport", city: "San Jose, CA" },
];

export const terminals = ["A", "B", "C", "D", "E", "F", "1", "2", "3", "4", "5"];
